import styled from 'styled-components';
import { rgba } from 'polished';

const InputCheckbox = styled.input.attrs({ type: 'checkbox' })`
  display: block;

  @supports (-webkit-appearance: none) or (-moz-appearance: none) {
    appearance: none;
    position: relative;
    height: ${({ theme }) => theme.spacing.baseUnit};
    width: ${({ theme }) => theme.spacing.baseUnit};
    margin: 0;
    border-radius: 5px;
    outline: none;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.grayDark};
    background-color: ${({ theme }) => theme.colors.white};
    transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;

    &:after {
      position: absolute;
      display: block;
      content: '';
      top: 3px;
      left: 6px;
      width: 4px;
      height: 9px;
      border: 2px solid ${({ theme }) => theme.colors.white};
      border-top: 0;
      border-left: 0;
      opacity: 0;
      transition: transform 0.3s ease, opacity 0.3s;
      transform: rotate(20deg);
    }

    &:checked {
      background-color: ${({ theme }) => theme.colors.action};
      border: 1px solid ${({ theme }) => theme.colors.action};

      &:after {
        opacity: 1;
        transform: rotate(43deg);
      }
    }

    &:disabled {
      background-color: ${({ theme }) => theme.colors.grayLight};
      pointer-events: none;
      opacity: 0.9;
    }

    &:hover {
      &:not(:checked) {
        &:not(:disabled) {
          border: 1px solid ${({ theme }) => theme.colors.action};
        }
      }
    }

    &:focus {
      box-shadow: ${({ theme }) =>
        `0 0 0 2px ${rgba(theme.colors.action, 0.3)}`}};
    }
  }
`;

export default InputCheckbox;
